interface SubscriptionDetailRowProps {
  label: string;
  value: string;
}

export const SubscriptionDetailRow = ({ label, value }: SubscriptionDetailRowProps) => (
  <div className="flex items-center justify-between">
    <dt className="text-zinc-500">{label}</dt>
    <dd className="font-medium text-zinc-800">{value}</dd>
  </div>
);
